module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product15-aded57be674593706c4ef3614b032f59.jpg";